var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"screener-question-number"},[_c('v-text-field',{attrs:{"type":"number","outlined":"","hide-details":"auto"},on:{"blur":function($event){return _vm.onChange()}},model:{value:(_vm.numberVal),callback:function ($$v) {_vm.numberVal=_vm._n($$v)},expression:"numberVal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }